// Stripe Elements gateway — scaffold so we can swap providers without
// touching the checkout pages. Loads stripe.js, asks the BFF for a
// PaymentIntent (capture_method = 'manual' for auth-only or 'automatic'
// for auth+capture), and would mount Elements into the container.
//
// Implementation is intentionally a stub that renders a placeholder
// when stripe.js / publishable key isn't configured, so the UI flow can
// be tried end-to-end before the BFF lands.

import { api } from "../api/client";

const STRIPE_SCRIPT = "https://js.stripe.com/v3/";

let _sdkPromise = null;
let _elements = null;

export const stripeGateway = {
  id: "stripe",
  label: "Stripe",
  features: {
    walletButtons: true,
    embeddedForm: true,
    hosted: true,
    savedCards: true,
  },

  async loadSdk() {
    if (typeof window === "undefined") return;
    if (window.Stripe) return;
    if (_sdkPromise) return _sdkPromise;
    _sdkPromise = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = STRIPE_SCRIPT;
      s.async = true;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error("Stripe SDK failed to load"));
      document.head.appendChild(s);
    });
    return _sdkPromise;
  },

  async createIntent({ orderId, amount, currency = "USD", capture = true, customer, items, metadata }) {
    if (typeof api.createStripeIntent === "function") {
      const out = await api.createStripeIntent({
        orderId, amount, currency, capture, customer, items, metadata,
      });
      return { token: out?.clientSecret, clientSecret: out?.clientSecret, intentId: out?.id, raw: out };
    }
    return { token: `dev-stripe-${Date.now()}`, intentId: orderId || `dev-${Date.now()}` };
  },

  async mount({ container, token, capture, on = {} }) {
    if (!container) throw new Error("container is required to mount Stripe");
    container.innerHTML = `
      <div style="padding:24px;border:1px dashed rgba(0,0,0,0.18);border-radius:8px;color:#555;font-size:0.9rem;line-height:1.5">
        <strong>Stripe gateway scaffold.</strong><br/>
        clientSecret = <code>${token || "(none)"}</code><br/>
        capture = <code>${capture ? "automatic" : "manual"}</code>
        <div style="margin-top:8px;color:#888">Wire stripe.js and Elements when this provider is selected.</div>
      </div>`;
    on.ready?.();
  },

  unmount() {
    _elements = null;
  },
};
